function recipientKey(item) {
    if (!item || item.userID == null || item.userID === '') {
        return '';
    }
    return String(item.userID);
}

function displayName(person) {
    return ((person.FirstName || '') + ' ' + (person.LastName || '')).trim().toLowerCase();
}

function isBought(item) {
    return item.isBought === true || item.isBought === 1 || item.isBought === '1';
}

// One box per gift-list owner. userID on each shopping-list row is that owner.
export function groupShoppingListByRecipient(shoppinglist) {
    const rows = Array.isArray(shoppinglist) ? shoppinglist : [];
    const groups = new Map();

    rows.forEach((item) => {
        const key = recipientKey(item);
        let person = groups.get(key);
        if (!person) {
            person = {
                FBID: item.FBID,
                FirstName: item.FirstName || '',
                LastName: item.LastName || '',
                avatarFile: item.avatarFile,
                urlCode: item.urlCode,
                userID: item.userID,
                items: []
            };
            groups.set(key, person);
        }
        person.items.push(item);
    });

    return Array.from(groups.values())
        .map((person) => ({
            ...person,
            items: person.items.slice().sort((a, b) => {
                const bought = isBought(a) - isBought(b);
                if (bought !== 0) {
                    return bought;
                }
                return String(a.itemName || '').localeCompare(String(b.itemName || ''));
            })
        }))
        .sort((a, b) => {
            const name = displayName(a).localeCompare(displayName(b));
            if (name !== 0) {
                return name;
            }
            return recipientKey(a).localeCompare(recipientKey(b));
        });
}

export function personShoppingTotal(items) {
    const rows = Array.isArray(items) ? items : [];
    return rows.reduce((sum, item) => {
        const amount = isBought(item) ? Number(item.amountSpent) : Number(item.itemPrice);
        return sum + (Number.isFinite(amount) ? amount : 0);
    }, 0);
}

// Checkbox saves must not replace the recipient id with the shopper id.
export function applyShoppingItemUpdate(existing, itemData) {
    return {
        ...existing,
        isBought: itemData.isBought,
        amountSpent: itemData.amountSpent
    };
}
